<main>
  @if (!showDetailTable) {
    <div class="container container-width ">
      <div class="border-bottom-1 d-flex w-100 mb-10 mt-1">
        <ul class="nav nav-tabs" role="listitem">
          <li class="nav-item" (click)="selectedTab ='all';getData()">
            <button class="nav-link" [ngClass]="selectedTab==='all'?'active':''" type="button" role="tab"
              [attr.aria-selected]="selectedTab==='all'" aria-controls="status-panel">
              Status
            </button>
          </li>
          <li class="nav-item" (click)="selectedTab ='queueSummary'; getQueueSummary()">
            <button class="nav-link" [ngClass]="selectedTab =='queueSummary'?'active':''" type="button" role="tab"
              [attr.aria-selected]="selectedTab==='queueSummary'" aria-controls="queue-summary-panel">
              Queue Summary
            </button>
          </li>
        </ul>
      </div>
      <div id="Status" class="sr-only">Status</div>
      @if (selectedTab === 'all') {
        <div class="table-message-count w-100" id="status-panel" role="tabpanel"
          aria-labelledby="Status">
          <table summary="Status Results">
            <tbody>
              <tr>
                <th scope="row">Message Counts</th>
                <td>Queued Count:</td>
                <td>{{muniStatus?.queuedCount}}</td>
              </tr>
              <tr>
                <td></td>
                <td>Unqueued Count:</td>
                <td>{{muniStatus?.unQueuedCount}}</td>
              </tr>
              <tr>
                <td></td>
                <td>Total Count:</td>
                <td>{{muniStatus?.totalCount}}</td>
              </tr>
              <tr>
                <td></td>
                <td>Collection Count:</td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
        </div>
      }
      @if (selectedTab === 'queueSummary' && !showDetailTable) {
        <div class="table-container w-100"
          id="queue-summary-panel" role="tabpanel">
          <div class="table-container w-100">
            <table class="table">
              <caption>Queue Summary Results</caption>
              <thead>
                <tr>
                  @for (col of tableHeaders; track col) {
                    <th scope="col">
                      <span role="button" tabindex="0" (click)="onSort($event,col.value,col.isSortable)"
                        (keydown.enter)="onSort($event,col.value,col.isSortable)"
                        (keydown.space)="onSort($event,col.value,col.isSortable)"
                        [attr.aria-label]="col.isSortable ? ('Sort by ' + col.header) : null">
                        {{col.header}}
                        @if (col.isSortable) {
                          <i class="fa fa-sort" aria-hidden="true"></i>
                        }
                      </span>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (item of getItems(); track item) {
                  <tr>
                    <td>{{item.courtNumber}}</td>
                    <td>{{item.courtName}}</td>
                    <td>{{item.vendorName}}</td>
                    <td>{{item.totalCount}}</td>
                    <td>
                      <a href="javascript:void(0)" class="details" (click)="showDetails(item)"
                        [attr.aria-label]="'Show queued details for ' + item.courtName">
                        {{item.queuedCount}}
                      </a>
                    </td>
                    <td>{{item.oldest}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="w-33">
              <span>
                {{tableData.totalElements}} items found, displaying {{getCurrentPageTotal()}} of
                {{tableData.totalElements}}
              </span>
            </div>
            <ngb-pagination [collectionSize]="tableData.totalElements" [(page)]="currentPage" [ellipses]="true"
              [maxSize]="10" (pageChange)="onPageChange(currentPage)" [pageSize]="10" [boundaryLinks]="true"
            aria-label="Queue summary pagination"></ngb-pagination>
            <div class="w-33"></div>
          </div>
        </div>
      }
    </div>
  }

  @if (showDetailTable) {
    <div class="container container-width ">
      <div class="topheadtitle">
        <h4>Download Queue for Muni Court #{{selectedCount}}</h4>
      </div>
      @if (alert) {
        <div class="alert alert-success mt-2" role="alert" aria-live="polite">{{alert.message}}</div>
      }
      <div class="table-container w-100">
        <div class="btn-group mb-2">
          @if (userTypeView === 'S') {
            <button type="button" class="btn btn-outline-primary mb-2"
            (click)="purgeData()">Purge</button>
          }
        </div>
        <table>
          <caption>Download Queue for Muni Court #{{selectedCount}}</caption>
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Citation Number</th>
              <th scope="col">Received</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            @for (item of getItems2(); track item; let i = $index) {
              <tr>
                <td>
                  <input type="checkbox" aria-label="select citation record" id="{{item.id}}"
                    [checked]="isSelected(item)" (change)="toggleSelection(item)" />
                  </td>
                  <td>{{item.citationNumber}}</td>
                  <td>{{item.createDate}}</td>
                  <td>{{details[item.deliveryStatusCd]}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <br />
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span>
              {{muniQueueSummary.totalElements}} items found, displaying
              {{ (currentPage*10 > muniQueueSummary.totalElements ) ? muniQueueSummary.totalElements : currentPage2*10
              }}
              of {{muniQueueSummary.totalElements}}
            </span>
          </div>
          <ngb-pagination [collectionSize]="muniQueueSummary.totalElements" [(page)]="currentPage2" [ellipses]="true"
            [maxSize]="10" (pageChange)="onPageChange2(currentPage2)" [pageSize]="10" [boundaryLinks]="true"
          aria-label="Download queue pagination"></ngb-pagination>
          <button type="button" class="btn btn-outline-primary"
            (click)="showDetailTable = false;currentPage2 = 1;selectedForPurge =[];getQueueSummary()">
            Go back to previous page
          </button>
        </div>
      </div>
    }
  </main>